import { render, staticRenderFns } from "./ListItemBid.vue?vue&type=template&id=9f5c9bc8"
import script from "./ListItemBid.vue?vue&type=script&lang=js"
export * from "./ListItemBid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports